import { ElementRef, EventEmitter } from '@angular/core';
import Uppy from '@uppy/core';
import XHRUpload from '@uppy/xhr-upload';
import { UPLOAD_ERROR_STATUS, UPLOAD_LOADING_STATUS, UPLOAD_OK_STATUS } from 'Angular/constants/data-upload.constants';
import { CookieService } from 'ngx-cookie-service';
import * as i0 from "@angular/core";
import * as i1 from "ngx-cookie-service";
import * as i2 from "@angular/common";
import * as i3 from "../../../directives/icon/icon.directive";
const _c0 = ["fileUpload"];
const _c1 = ["fileUploadReplace"];
const _c2 = (a0, a1, a2) => ({ "is-invalid": a0, "is-valid": a1, "disabled": a2 });
function MultilineFileUploadComponent_div_30_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 20)(1, "p");
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(2, "svg", 21);
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("name", "icon-check");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.successfulUploadConfirmMessage);
} }
function MultilineFileUploadComponent_div_31_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 24);
} if (rf & 2) {
    const error_r3 = ctx.$implicit;
    i0.ɵɵproperty("innerHTML", error_r3, i0.ɵɵsanitizeHtml);
} }
function MultilineFileUploadComponent_div_31_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 20)(1, "div", 22)(2, "strong");
    i0.ɵɵtext(3, "File errors:");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, MultilineFileUploadComponent_div_31_div_4_Template, 1, 1, "div", 23);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngForOf", ctx_r1.state.errors);
} }
export class MultilineFileUploadComponent {
    constructor(cookieService) {
        this.cookieService = cookieService;
        this.errorHandler = new EventEmitter();
        this.successfulUploadConfirmMessage = 'Your file is in the correct format.';
        this.maxFileSizeInBytes = 1024 * 10000;
        this.previousEvent = null;
        this.state = {
            errors: [],
            hasBrowsed: false,
            file: null,
            fileStatus: null,
            modalOpen: false,
            requirementsVisible: false,
        };
        this.UPLOAD_LOADING_STATUS = UPLOAD_LOADING_STATUS;
        this.UPLOAD_OK_STATUS = UPLOAD_OK_STATUS;
        this.UPLOAD_ERROR_STATUS = UPLOAD_ERROR_STATUS;
        this.uploadListener = (evt) => {
            evt.preventDefault();
            this.previousEvent = evt;
            if (evt.type === 'drop') {
                const { dataTransfer } = evt;
                if (!dataTransfer)
                    return;
                // eslint-disable-next-line prefer-destructuring
                this.state.file = dataTransfer.files[0];
            }
            else if (evt.type === 'change') {
                const { files } = evt.target;
                if (!files)
                    return;
                // eslint-disable-next-line prefer-destructuring
                this.state.file = files[0];
            }
            if (!this.state.file)
                return;
            // Pre-validate file before creating Uppy instance to avoid error being thrown
            if (this.state.file.type && !this.validFileTypesType.includes(this.state.file.type)) {
                this.state.errors = [`File '${this.state.file.name}' does not have a valid file type`];
                this.state.fileStatus = UPLOAD_ERROR_STATUS;
                return;
            }
            if (this.state.file.size > this.maxFileSizeInBytes) {
                this.state.errors = [
                    `File '${this.state.file.name}' is bigger than the max size. Max size: ${this.maxFileSizeInBytes}`,
                ];
                this.state.fileStatus = UPLOAD_ERROR_STATUS;
                return;
            }
            const uppy = new Uppy({
                autoProceed: true,
                onBeforeFileAdded: () => {
                    // File validation happens before Uppy instance creation.
                    // If we reach here, the file is valid, so set status to loading.
                    this.state.fileStatus = UPLOAD_LOADING_STATUS;
                    return true;
                },
            });
            uppy.addFile({
                name: this.state.file.name,
                type: this.state.file.type,
                data: this.state.file,
            });
            const csrfToken = this.cookieService.get('csrftoken');
            uppy.use(XHRUpload, {
                endpoint: this.uploadUrl,
                formData: true,
                fieldName: this.uploadFieldName,
                timeout: 5 * 60 * 1000, // Set timeout to 5 minutes (in milliseconds) for large files.
                shouldRetry() {
                    return false;
                },
                withCredentials: true,
                headers: {
                    'X-CSRFToken': csrfToken,
                },
            });
            uppy.on('upload-error', (file, _error, xmlRequest) => {
                const response = JSON.parse(xmlRequest.response);
                const errors = response.errors ? ` ${response.errors.join(' ')}` : 'Something went wrong.';
                this.errorHandler.emit(response);
                this.state.errors = [
                    `Error uploading "${file ? file.name : 'file'}."${errors} Please try again or contact support.`,
                ];
                this.state.fileStatus = UPLOAD_ERROR_STATUS;
            });
            uppy.on('complete', (result) => {
                // We don't expect his to happen; but if there is no successful result,
                // then check to make sure an error is already being shown
                // otherwise if no error is being shown show one.
                if (!result.successful ||
                    result.successful.length < 1 ||
                    !result.successful[0].response ||
                    !result.successful[0].response.body) {
                    if (this.state.fileStatus !== UPLOAD_ERROR_STATUS) {
                        this.state.fileStatus = UPLOAD_ERROR_STATUS;
                        this.state.errors = ['Unknown error uploading file. Please try again or contact support.'];
                    }
                    return;
                }
                const { status, errors } = result.successful[0].response.body;
                this.state = {
                    ...this.state,
                    fileStatus: status,
                    errors,
                };
            });
        };
    }
    retryWithUrl(url) {
        if (!this.previousEvent) {
            return;
        }
        const temp = this.uploadUrl;
        this.uploadUrl = url;
        this.uploadListener(this.previousEvent);
        this.uploadUrl = temp;
    }
    ngAfterViewInit() {
        document.body.addEventListener('drop', this.uploadListener);
        this.fileUpload.nativeElement.addEventListener('change', this.uploadListener);
        this.fileUploadReplace.nativeElement.addEventListener('change', this.uploadListener);
    }
    clearSelectedFile() {
        // If we are in the middle of uploading do not allow the user to cancel.
        if (this.state.fileStatus === UPLOAD_LOADING_STATUS) {
            return;
        }
        this.state.file = null;
        this.state.fileStatus = null;
        this.state.errors = [];
        this.fileUpload.nativeElement.value = null;
        this.fileUploadReplace.nativeElement.value = null;
    }
}
MultilineFileUploadComponent.ɵfac = function MultilineFileUploadComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || MultilineFileUploadComponent)(i0.ɵɵdirectiveInject(i1.CookieService)); };
MultilineFileUploadComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MultilineFileUploadComponent, selectors: [["ycn-multiline-file-upload"]], viewQuery: function MultilineFileUploadComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
        i0.ɵɵviewQuery(_c1, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.fileUpload = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.fileUploadReplace = _t.first);
    } }, inputs: { uploadUrl: "uploadUrl", uploadFieldName: "uploadFieldName", validFileTypesType: "validFileTypesType", successfulUploadConfirmMessage: "successfulUploadConfirmMessage", maxFileSizeInBytes: "maxFileSizeInBytes" }, outputs: { errorHandler: "errorHandler" }, standalone: false, decls: 32, vars: 15, consts: [["fileUpload", ""], ["fileUploadReplace", ""], [3, "hidden"], [1, "d-flex", "flex-column", "mb-2", 3, "click"], [1, "btn-upload"], [1, "btn-upload-line"], ["ycnIcon", "", 3, "name"], [1, "text-uppercase"], ["type", "file", 2, "display", "none"], [1, "mb-2"], [1, "form-row", "text-center", 3, "hidden"], [1, "text-blue"], [1, "page-progress-bar"], [1, "field-input-group", "input-group"], ["type", "text", "readonly", "", 1, "form-control", 3, "value", "ngClass"], [1, "field-input-group-actions"], [1, "btn", "btn-transparent", 3, "click"], [1, "btn", "btn-secondary"], ["type", "file", 2, "display", "none", 3, "disabled"], ["class", "form-row", 4, "ngIf"], [1, "form-row"], ["ycnIcon", "", 1, "index-change-up", 3, "name"], [1, "text-red"], [3, "innerHTML", 4, "ngFor", "ngForOf"], [3, "innerHTML"]], template: function MultilineFileUploadComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "div", 2)(1, "label", 3);
        i0.ɵɵlistener("click", function MultilineFileUploadComponent_Template_label_click_1_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.state.hasBrowsed = true); });
        i0.ɵɵelementStart(2, "div", 4)(3, "strong", 5);
        i0.ɵɵtext(4, "Drop your file");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "span", 5);
        i0.ɵɵtext(6, "or");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "span", 5);
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelement(8, "svg", 6);
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelementStart(9, "strong", 7);
        i0.ɵɵtext(10, "Browse for file from computer");
        i0.ɵɵelementEnd()();
        i0.ɵɵelement(11, "input", 8, 0);
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(13, "div", 2)(14, "div", 9)(15, "div", 10)(16, "span", 11);
        i0.ɵɵtext(17, "Uploading file...");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(18, "div", 12);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(19, "div", 13);
        i0.ɵɵelement(20, "input", 14);
        i0.ɵɵelementStart(21, "div", 15)(22, "div", 16);
        i0.ɵɵlistener("click", function MultilineFileUploadComponent_Template_div_click_22_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.clearSelectedFile()); });
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelement(23, "svg", 6);
        i0.ɵɵelementEnd();
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelementStart(24, "label", 17);
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelement(25, "svg", 6);
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelementStart(26, "span");
        i0.ɵɵtext(27, "Browse");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(28, "input", 18, 1);
        i0.ɵɵelementEnd()()()()();
        i0.ɵɵtemplate(30, MultilineFileUploadComponent_div_30_Template, 5, 2, "div", 19)(31, MultilineFileUploadComponent_div_31_Template, 5, 1, "div", 19);
    } if (rf & 2) {
        i0.ɵɵproperty("hidden", ctx.state.file);
        i0.ɵɵadvance(8);
        i0.ɵɵproperty("name", "icon-browse");
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("hidden", !ctx.state.file);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("hidden", ctx.state.fileStatus !== ctx.UPLOAD_LOADING_STATUS);
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("value", ctx.state.file ? ctx.state.file.name : "")("ngClass", i0.ɵɵpureFunction3(11, _c2, ctx.state.fileStatus === ctx.UPLOAD_ERROR_STATUS, ctx.state.fileStatus === ctx.UPLOAD_OK_STATUS, ctx.state.fileStatus === ctx.UPLOAD_LOADING_STATUS));
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("name", "icon-close");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("name", "icon-browse");
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("disabled", ctx.state.fileStatus === ctx.UPLOAD_LOADING_STATUS);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.state.fileStatus === ctx.UPLOAD_OK_STATUS);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.state.fileStatus === ctx.UPLOAD_ERROR_STATUS);
    } }, dependencies: [i2.NgClass, i2.NgForOf, i2.NgIf, i3.IconDirective], encapsulation: 2 });
